// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__zcyng","panel__company-list":"Panel_panel__company-list__3gljO","loader":"Panel_loader__i+9QB","panel__list":"Panel_panel__list__CMWoQ"};